<template>
	<div id="error" class="error" :class="isForbidden && 'error--forbidden'">
		<div class="logo-container">
			<svgIcon icon-holder-class="logo" icon-id="nexon-logo" />
		</div>

		<div class="logo-icon" />

		<h1 class="heading-normal text-white text-center">
			{{ errorTitle }}
		</h1>
		<p class="error-desc text-center">{{ errorDescription }}</p>

		<button v-if="!isForbidden" class="btn btn-gradient back-to-home" @click="backToHome">
			{{ $t('main.home') }}
		</button>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';

export default {
	name: 'Error',
	components: {
		svgIcon,
	},
	props: {},
	computed: {
		returnErrorCode() {
			return this.$route.query.error ? this.$route.query.error : 404;
		},
		isForbidden() {
			return this.$route.query && this.$route.query.error && this.$route.query.error === 'forbidden';
		},
		errorTitle() {
			return this.$te(`main.error.${this.returnErrorCode}`)
				? this.$t(`main.error.${this.returnErrorCode}`)
				: this.$t(`main.error.404`);
		},
		errorDescription() {
			return this.$te(`main.error.${this.returnErrorCode}-desc`)
				? this.$t(`main.error.${this.returnErrorCode}-desc`)
				: this.$t(`main.error.404-desc`);
		},
	},
	methods: {
		backToHome() {
			location.href = '/main/';
		},
	},
};
</script>

<style lang="less" scoped>
.logo-icon {
	width: 122px;
	height: 134px;
	margin: 0 auto 50px;
	display: block;
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	background-image: url('~@/images/error/logo-error.png');
}
#error {
	&.error--forbidden {
		.logo-icon {
			width: 100px;
			height: 100px;
			background-image: url('~@/images/error/logo-no-access.png');
		}
	}
}
</style>
